<template>
  <div class="activity-logs">
    <v-row>
      <v-col>
        <breadcrumb :items="breadcrumbs" />
      </v-col>
    </v-row>
    <activity-log-table />
  </div>
</template>

<script>
import BreadCrumb from '@/components/partials/BreadCrumb.vue'
import ActivityLogTable from '@/components/tables/ActivityLogTable.vue'

export default {
  components: {
    breadcrumb: BreadCrumb,
    'activity-log-table': ActivityLogTable,
  },
  data() {
    return {
      breadcrumbs: [
        {
          text: 'Dashboard',
          disabled: false,
          to: { name: 'dashboard' },
        },
        {
          text: 'Activity Logs',
          disabled: true,
          to: { name: 'activity-logs' },
        },
      ],
    }
  },
}
</script>
